export enum BuilderSliderOptions {
  FACADES = "facades",
  INTERIORS = "interiors",
  ABOUT = "about",
  FLOOR_PLANS = "floors plans",
  INCLUSIONS = "inclusions",
}
